import { render } from "./corporateDetails.vue?vue&type=template&id=a3995d8c"
import script from "./corporateDetails.vue?vue&type=script&lang=js"
export * from "./corporateDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__